import { render, staticRenderFns } from "./alarms-table.vue?vue&type=template&id=247ea550&scoped=true&"
import script from "./alarms-table.vue?vue&type=script&lang=js&"
export * from "./alarms-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247ea550",
  null
  
)

export default component.exports